import React, { Component } from 'react';
import {
  message,
  PageHeader,
  Steps,
  Card,
  Radio,
  Table,
  Select,
  InputNumber,
  Row,
  Col,
  Spin,
} from 'antd';
import axios from 'axios';
import { connect } from 'react-redux';
import { ButtonItem, dineroDisabledMask } from '../../../../Components/Items';
import moment from 'moment';
import 'moment/locale/es';

const { Step } = Steps;
const { Option } = Select;

moment.locale('es');

class ProrratearFactura extends Component {
  state = {
    loading: false,
    paso: 0,
    id: this.props.location.state?.id,

    // Paso 0
    metodo: null, // 'facturaCompleta' | 'insumoFactura' | 'insumoCompleto'

    // Paso 1
    facturasProrrateo: [],
    facturaOrigenId: null,
    facturaOrigen: null,

    // Paso 2
    distribucionMetodo: 'A',
    insumoObjetivoId: null,
    insumosObjetivo: [],
    insumosExcluidosIds: [],
    insumosOrigen: [],
    montosOrigen: {},
  };

  componentDidMount() {
    this.cargarInsumosObjetivo();
  }

  async cargarInsumosObjetivo() {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        'facturassinordendecompra/datosFacturaPRecibirP',
        { empresaId: this.props.empresaId, facturaId: this.state.id },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        const catalogoInsumos = res.data.insumos || [];
        const insumosObjetivo = (res.data.factura?.insumos || []).map(li => {
          const insumoId = li.insumoId?._id ?? li.insumoId;
          const catalogo = catalogoInsumos.find(ins => String(ins._id) === String(insumoId)) || {};
          return { ...li, stringBuscar: catalogo.stringBuscar || '' };
        });
        this.setState({ insumosObjetivo });
      } else {
        message.error('Error al cargar datos de la factura');
      }
    } catch {
      message.error('Error al cargar datos de la factura');
    }
    this.setState({ loading: false });
  }

  async cargarFacturasProrrateo() {
    if (this.state.facturasProrrateo.length > 0) return;
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        'prorrateo/selectConsultasAProrratear',
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        this.setState({ facturasProrrateo: res.data.data });
      } else {
        message.warn('No hay facturas pendientes de prorratear');
      }
    } catch {
      message.error('Error al cargar facturas de prorrateo');
    }
    this.setState({ loading: false });
  }

  async cargarInsumosOrigen(facturaOrigenId) {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        'facturassinordendecompra/datosFacturaPRecibirP',
        { empresaId: this.props.empresaId, facturaId: facturaOrigenId },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        const catalogoInsumos = res.data.insumos || [];
        const insumosOrigen = (res.data.factura?.insumos || []).map(li => {
          const insumoId = li.insumoId?._id ?? li.insumoId;
          const catalogo = catalogoInsumos.find(ins => String(ins._id) === String(insumoId)) || {};
          return { ...li, stringBuscar: catalogo.stringBuscar || '' };
        });
        this.setState({ insumosOrigen });
      }
    } catch {
      message.error('Error al cargar insumos de la factura de prorrateo');
    }
    this.setState({ loading: false });
  }

  siguientePaso() {
    const { paso } = this.state;
    if (paso === 0) {
      this.setState({ paso: 1 }, () => this.cargarFacturasProrrateo());
    } else if (paso === 1) {
      this.setState({ paso: 2 });
    }
  }

  anteriorPaso() {
    this.setState(s => ({ paso: s.paso - 1 }));
  }

  async aplicarProrrateo() {
    const {
      metodo,
      facturaOrigenId,
      id: facturaObjetivoId,
      distribucionMetodo,
      insumoObjetivoId,
      insumosExcluidosIds,
      montosOrigen,
      insumosOrigen,
    } = this.state;
    this.setState({ loading: true });

    let endpoint, body;

    if (metodo === 'facturaCompleta') {
      endpoint = 'prorrateo/prorratearFacturaCompleta';
      body = {
        empresaId: this.props.empresaId,
        facturaOrigenId,
        facturaObjetivoId,
        metodo: distribucionMetodo,
        insumosExcluidosIds,
      };
    } else if (metodo === 'insumoFactura') {
      endpoint = 'prorrateo/prorratearInsumoFactura';
      body = {
        empresaId: this.props.empresaId,
        facturaOrigenId,
        facturaObjetivoId,
        insumoObjetivoId,
      };
    } else {
      endpoint = 'prorrateo/prorrateoInsumoCompleto';
      const insumosOrigenFiltrados = insumosOrigen
        .filter(i => (montosOrigen[i._id] || 0) > 0)
        .map(i => ({ insumoId: i._id, monto: montosOrigen[i._id] }));
      body = {
        empresaId: this.props.empresaId,
        facturaOrigenId,
        facturaObjetivoId,
        insumoObjetivoId,
        insumosOrigen: insumosOrigenFiltrados,
      };
    }

    try {
      const res = await axios.post(endpoint, body, { headers: this.props.headersToken });
      if (res.data.success === 2) {
        message.success('Prorrateo aplicado, folio: ' + res.data.folio);
        this.props.history.push('/panel/facturasSinOrdenDeCompra');
      } else {
        message.error(res.data.message || 'Error al aplicar prorrateo');
      }
    } catch {
      message.error('Error al aplicar prorrateo');
    }
    this.setState({ loading: false });
  }

  renderPaso0() {
    const { metodo } = this.state;
    const opciones = [
      {
        value: 'facturaCompleta',
        title: 'Factura completa',
        desc: 'Distribuye todo el costo de la factura de prorrateo entre todos los insumos de la factura objetivo',
      },
      {
        value: 'insumoFactura',
        title: 'Insumo de factura',
        desc: 'Aplica todo el costo de la factura de prorrateo a un solo insumo de la factura objetivo',
      },
      {
        value: 'insumoCompleto',
        title: 'Insumo completo',
        desc: 'Elige qué insumos y qué cantidad de la factura de prorrateo se distribuyen hacia un insumo destino',
      },
    ];
    return (
      <div style={{ maxWidth: 700, margin: '24px auto' }}>
        <Radio.Group
          value={metodo}
          onChange={e => this.setState({ metodo: e.target.value })}
          style={{ width: '100%' }}
        >
          <Row gutter={[16, 16]}>
            {opciones.map(opt => (
              <Col span={8} key={opt.value}>
                <Card
                  hoverable
                  onClick={() => this.setState({ metodo: opt.value })}
                  style={{
                    border: metodo === opt.value ? '2px solid #00BFD6' : '1px solid #d9d9d9',
                    cursor: 'pointer',
                  }}
                >
                  <Radio value={opt.value}>
                    <strong>{opt.title}</strong>
                  </Radio>
                  <p style={{ marginTop: 8, fontSize: 12, color: '#666' }}>{opt.desc}</p>
                </Card>
              </Col>
            ))}
          </Row>
        </Radio.Group>
        <div style={{ marginTop: 24, textAlign: 'right' }}>
          <ButtonItem
            type="primary"
            disabled={!metodo}
            onClick={() => this.siguientePaso()}
          >
            Siguiente
          </ButtonItem>
        </div>
      </div>
    );
  }

  renderPaso1() {
    const { facturasProrrateo, facturaOrigenId } = this.state;
    const columns = [
      { title: 'Código', dataIndex: 'codigoFactura', key: 'codigoFactura', width: '12%' },
      { title: 'Núm', dataIndex: 'numeroFactura', key: 'numeroFactura', width: '10%' },
      {
        title: 'Proveedor',
        dataIndex: 'proveedor',
        key: 'proveedor',
        render: v => v?.razonSocial,
        width: '25%',
        ellipsis: true,
      },
      {
        title: 'Proyecto',
        dataIndex: 'proyecto',
        key: 'proyecto',
        render: v => v?.nombre,
        width: '18%',
        ellipsis: true,
      },
      {
        title: 'Total',
        dataIndex: 'totalPagar',
        key: 'totalPagar',
        render: v => dineroDisabledMask(v),
        align: 'right',
        width: '12%',
      },
      {
        title: 'Prorrateado',
        dataIndex: 'totalProrrateado',
        key: 'totalProrrateado',
        render: v => dineroDisabledMask(v),
        align: 'right',
        width: '12%',
      },
      {
        title: 'Pendiente',
        key: 'pendiente',
        render: (_, r) => dineroDisabledMask(r.totalPagar - r.totalProrrateado),
        align: 'right',
        width: '11%',
      },
    ];

    const seleccionarFila = record => {
      this.setState({ facturaOrigenId: record._id, facturaOrigen: record }, () => {
        if (this.state.metodo === 'insumoCompleto') {
          this.cargarInsumosOrigen(record._id);
        }
      });
    };

    return (
      <div style={{ margin: '24px 0' }}>
        <Table
          size="small"
          dataSource={facturasProrrateo}
          columns={columns}
          rowKey="_id"
          rowSelection={{
            type: 'radio',
            selectedRowKeys: facturaOrigenId ? [facturaOrigenId] : [],
            onChange: (keys, rows) => seleccionarFila(rows[0]),
          }}
          onRow={record => ({ onClick: () => seleccionarFila(record) })}
          pagination={false}
          locale={{ emptyText: 'No hay facturas pendientes de prorratear' }}
        />
        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between' }}>
          <ButtonItem onClick={() => this.anteriorPaso()}>Atrás</ButtonItem>
          <ButtonItem
            type="primary"
            disabled={!facturaOrigenId}
            onClick={() => this.siguientePaso()}
          >
            Siguiente
          </ButtonItem>
        </div>
      </div>
    );
  }

  renderPaso2() {
    const {
      metodo,
      distribucionMetodo,
      insumoObjetivoId,
      insumosObjetivo,
      insumosExcluidosIds,
      insumosOrigen,
      montosOrigen,
      facturaOrigen,
    } = this.state;

    const pendiente = facturaOrigen
      ? facturaOrigen.totalPagar - facturaOrigen.totalProrrateado
      : 0;

    const totalCalculado = Object.values(montosOrigen).reduce((sum, v) => sum + (v || 0), 0);

    const puedeAplicar =
      metodo === 'facturaCompleta'
        ? insumosExcluidosIds.length < insumosObjetivo.length
        : metodo === 'insumoFactura'
        ? !!insumoObjetivoId
        : totalCalculado > 0 && !!insumoObjetivoId;

    return (
      <div style={{ maxWidth: 800, margin: '24px auto' }}>
        <Card size="small" style={{ marginBottom: 16 }}>
          <Row gutter={16}>
            <Col span={14}>
              <strong>Factura de prorrateo:</strong>{' '}
              {facturaOrigen?.codigoFactura} — {facturaOrigen?.proveedor?.razonSocial}
            </Col>
            <Col span={10}>
              <strong>Monto pendiente:</strong> {dineroDisabledMask(pendiente)}
            </Col>
          </Row>
        </Card>

        {metodo === 'facturaCompleta' && (
          <div style={{ marginBottom: 16 }}>
            <p>
              <strong>Método de distribución:</strong>
            </p>
            <Radio.Group
              value={distribucionMetodo}
              onChange={e => this.setState({ distribucionMetodo: e.target.value })}
              style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
            >
              {[
                {
                  value: 'A',
                  titulo: 'A — Proporcional al valor',
                  desc: 'Distribuye el costo proporcionalmente al subtotal de cada entrada. Si una entrada vale el 60% del total, absorbe el 60% del prorrateo.',
                },
                {
                  value: 'B',
                  titulo: 'B — Proporcional a la cantidad',
                  desc: 'Divide el monto entre la cantidad total de unidades de todas las entradas. Cada unidad absorbe la misma cantidad fija de costo adicional.',
                },
                {
                  value: 'C',
                  titulo: 'C — Igual por insumo (línea)',
                  desc: 'Divide el monto entre el número de insumos distintos, y luego entre la cantidad de esa entrada para obtener el costo por unidad. Cada línea absorbe la misma fracción sin importar cuántas unidades tenga.',
                },
              ].map(opt => (
                <Radio key={opt.value} value={opt.value}>
                  <strong>{opt.titulo}</strong>
                  <div style={{ fontSize: 12, color: '#666', marginTop: 2, whiteSpace: 'normal', maxWidth: 560 }}>
                    {opt.desc}
                  </div>
                </Radio>
              ))}
            </Radio.Group>

            <p style={{ marginTop: 16 }}>
              <strong>Insumos de la factura:</strong> marca los que NO deben participar en este prorrateo.
            </p>
            <Table
              size="small"
              rowKey="_id"
              dataSource={insumosObjetivo}
              pagination={false}
              rowSelection={{
                selectedRowKeys: insumosExcluidosIds,
                onChange: keys => this.setState({ insumosExcluidosIds: keys }),
              }}
              columns={[
                { title: 'Insumo', dataIndex: 'stringBuscar', key: 'stringBuscar', ellipsis: true },
                {
                  title: 'Subtotal',
                  key: 'subtotal',
                  align: 'right',
                  width: 120,
                  render: (_, record) => dineroDisabledMask(record.subtotal || 0),
                },
              ]}
            />
          </div>
        )}

        {metodo === 'insumoFactura' && (
          <div style={{ marginBottom: 16 }}>
            <p>
              <strong>Insumo destino:</strong>
            </p>
            <Select
              style={{ width: '100%' }}
              placeholder="Selecciona un insumo de la factura objetivo"
              value={insumoObjetivoId}
              onChange={v => this.setState({ insumoObjetivoId: v })}
            >
              {insumosObjetivo.map(i => {
                const subtotal = i.precioUnitario ?? i.subtotal ?? (i.precioUnitario || 0) * (i.cantidad || 0);
                return (
                  <Option key={i._id} value={i._id}>
                    <span>{i.stringBuscar}</span>
                    <span style={{ float: 'right', color: '#888', fontSize: 12 }}>
                      {dineroDisabledMask(subtotal)}
                    </span>
                  </Option>
                );
              })}
            </Select>
          </div>
        )}

        {metodo === 'insumoCompleto' && (
          <>
            <p>
              <strong>
                Insumos de la factura de prorrateo (ingresa monto a distribuir):
              </strong>
            </p>
            <Table
              size="small"
              dataSource={insumosOrigen}
              rowKey="_id"
              pagination={false}
              style={{ marginBottom: 12 }}
              columns={[
                {
                  title: 'Insumo',
                  dataIndex: 'stringBuscar',
                  key: 'stringBuscar',
                  ellipsis: true,
                },
                {
                  title: 'Subtotal',
                  key: 'subtotal',
                  align: 'right',
                  width: 120,
                  render: (_, record) =>
                    dineroDisabledMask(record.subtotal - (record.montoProrrateado || 0)),
                },
                {
                  title: 'Monto',
                  key: 'montoInput',
                  align: 'right',
                  width: 140,
                  render: (_, record) => (
                    <InputNumber
                      min={0}
                      max={record.subtotal - (record.montoProrrateado || 0)}
                      value={montosOrigen[record._id] || 0}
                      onChange={v =>
                        this.setState(s => ({
                          montosOrigen: { ...s.montosOrigen, [record._id]: v || 0 },
                        }))
                      }
                      formatter={v => `$ ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      parser={v => v.replace(/\$\s?|(,*)/g, '')}
                      size="small"
                      style={{ width: 120 }}
                    />
                  ),
                },
              ]}
            />
            <div style={{ marginBottom: 12 }}>
              <strong>Total a prorratear: {dineroDisabledMask(totalCalculado)}</strong>
            </div>
            <p>
              <strong>Insumo destino:</strong>
            </p>
            <Select
              style={{ width: '100%' }}
              placeholder="Selecciona un insumo de la factura objetivo"
              value={insumoObjetivoId}
              onChange={v => this.setState({ insumoObjetivoId: v })}
            >
              {insumosObjetivo.map(i => {
                const subtotal = i.precioUnitario ?? i.subtotal ?? (i.precioUnitario || 0) * (i.cantidad || 0);
                return (
                  <Option key={i._id} value={i._id}>
                    <span>{i.stringBuscar}</span>
                    <span style={{ float: 'right', color: '#888', fontSize: 12 }}>
                      {dineroDisabledMask(subtotal)}
                    </span>
                  </Option>
                );
              })}
            </Select>
          </>
        )}

        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'space-between' }}>
          <ButtonItem onClick={() => this.anteriorPaso()}>Atrás</ButtonItem>
          <ButtonItem
            type="primary"
            disabled={!puedeAplicar}
            onClick={() => this.aplicarProrrateo()}
          >
            Aplicar prorrateo
          </ButtonItem>
        </div>
      </div>
    );
  }

  render() {
    const { paso, loading } = this.state;
    return (
      <Spin spinning={loading}>
        <PageHeader
          title="Prorrateo de costos"
          onBack={() => this.props.history.push('/panel/facturasSinOrdenDeCompra')}
          style={{
            border: '1px solid rgb(235, 237, 240)',
            backgroundColor: 'white',
            marginBottom: 10,
          }}
        />
        <div style={{ backgroundColor: 'white', padding: 24 }}>
          <Steps current={paso} size="small" style={{ marginBottom: 24 }}>
            <Step title="Método" description="Elige cómo prorratear" />
            <Step title="Factura origen" description="Selecciona la factura de prorrateo" />
            <Step title="Configurar" description="Ajusta y confirma" />
          </Steps>
          {paso === 0 && this.renderPaso0()}
          {paso === 1 && this.renderPaso1()}
          {paso === 2 && this.renderPaso2()}
        </div>
      </Spin>
    );
  }
}

const mapStateToProps = state => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ProrratearFactura);
